import React, { useEffect, useState } from "react";
import style from './HealthStatus.module.scss';
import StatusItem from './StatusItem'
import ProgressItem from './Item'
import HealthStatusTextField from './HealthStatusTextField'
import { filterHealthStatus } from '../../../store/actions/projects.actions'
import $ from "jquery";
import { useDispatch } from "react-redux";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { getEditPermission, resetUtcDate } from "../../../helpers/utils";
import { LockSvg } from "../../../modules/default-svg";
import moment from "moment/moment";
dayjs.extend(utc);

const HealthStatus = (props) => {
    const { projectID, metrixList, updateStatusKPI, getMetrics, handleUpdateGLobalStatus, handleUpdatePeriod } = props;
    const [progressTracker, setProgressTracker] = useState({});
    const [progressTrackerPeriod, setProgressTrackerPeriod] = useState('');
    const settings = JSON.parse(localStorage.getItem("settings"));
    const [setting] = useState(settings);
    const [global, setGLobal] = useState([]);
    const [scope, setScope] = useState([]);
    const [time, setTime] = useState([]);
    const [cost, setCost] = useState([]);
    const [quality, setQuality] = useState([]);
    const [issues, setIssues] = useState([]);
    const [risks, setRisks] = useState([]);
    const [resources, setResources] = useState([]);
    const [currentPeriodProgress, setCurrentPeriodProgress] = useState({});
    const [nextPeriodProgressForecast, setNextPeriodProgressForecast] = useState({});
    const [majorRisksIssues, setMajorRisksIssues] = useState({});
    const [specialConcerns, setSpecialConcerns] = useState("");
    const [readOnly, setReadOnly] = useState(false);
    const dispatch = useDispatch();

    const handleUpdateStatus = (payload) => {
        updateStatusKPI({ id: projectID, payload })
        if (payload.kpi === "ProjectHealth")
            handleUpdateGLobalStatus({ isForecast: payload.isForecast, status: payload.status });
    }

    useEffect(() => {
        getMetrics(projectID);
    }, []);

    useEffect(() => {
        if (metrixList.hasOwnProperty('period') || metrixList.hasOwnProperty('healthStatus')) {
            setGLobal(metrixList.healthStatus && metrixList.healthStatus.global);
            setScope(metrixList.healthStatus && metrixList.healthStatus.scope);
            setTime(metrixList.healthStatus && metrixList.healthStatus.time);
            setCost(metrixList.healthStatus && metrixList.healthStatus.cost);
            setQuality(metrixList.healthStatus && metrixList.healthStatus.quality);
            setIssues(metrixList.healthStatus && metrixList.healthStatus.issues_Concerns);
            setRisks(metrixList.healthStatus && metrixList.healthStatus.risks);
            setResources(metrixList.healthStatus && metrixList.healthStatus.resources_Team);
            setProgressTracker(metrixList.progressTracker);
            setProgressTrackerPeriod(metrixList.progressTracker && metrixList.progressTracker.period);
            const data = {
                startCurrent: metrixList?.period ? moment(metrixList?.period?.startCurrent).toDate() : '',
                endCurrent: metrixList?.period ? moment(metrixList?.period?.endCurrent).toDate() : '',
            };

            if (metrixList?.period?.startCurrent && metrixList?.period?.endCurrent) {
                $("input[name='datetimes']").daterangepicker({
                    startDate: data.startCurrent,
                    endDate: data.endCurrent,
                    locale: {
                        format: setting.regionalSettings.dateFormat.toUpperCase()
                    }
                });
                handleUpdatePeriod(moment(metrixList?.period?.endCurrent).format('YYYY-MM-DD'));
            }

            $("input[name='datetimes']").on('apply.daterangepicker', (e, picker) => {
                const newStartDate = picker.startDate.format('YYYY-MM-DD');
                dispatch(filterHealthStatus({ id: projectID, data: { date: newStartDate } }));
            });

            setReadOnly(!getEditPermission("Project") || metrixList?.isDisabled);
            if (metrixList?.healthStatus?.global) {
                metrixList?.healthStatus?.global?.map(kpi => handleUpdateGLobalStatus(kpi))
            }
            return () => {
                $("input[name='datetimes']").daterangepicker('destroy');  // Clean up the daterangepicker instance on unmount or update
            };
        }
    }, [metrixList])


    useEffect(() => {
        if (Object.keys(progressTracker).length > 0) {
            setCurrentPeriodProgress(progressTracker.currentPeriodProgress);
            setNextPeriodProgressForecast(progressTracker.nextPeriodProgressForecast);
            setMajorRisksIssues(progressTracker.majorRisksIssues || {});
            setSpecialConcerns(progressTracker.specialConcerns || "");
        }
    }, [progressTracker]);

    return (
        <>
            <div className={style.mainScroller}>
                <div>
                    <div className="row gx-3">
                        <div className="col-1">
                            <div className={style.staticLabelHeading}>
                                <h5>KPI</h5>
                            </div>
                        </div>
                        <div className="col-11">
                            <div className="flex gx-0 bg-[#f0f0f0]">
                                <div className="flex col-2 text-center">
                                    <div className="w-50">
                                        <div className={style.innerHeading}>
                                            <h5>Current</h5>
                                        </div>
                                    </div>
                                    <div className="w-50">
                                        <div className={style.innerHeading}>
                                            <h5>Trending</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex col-10 align-items-center justify-content-end px-2">
                                    <StatusItem item={global} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} isGlobal />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${style.kpiRow} row gx-3`}>
                        <div className="col-1">
                            <div className={style.staticLabel}>
                                Scope
                            </div>
                        </div>
                        <div className="col-11">
                            <div className="row gx-3">
                                <StatusItem item={scope} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={`${style.kpiRow} row gx-3`}>
                        <div className="col-1">
                            <div className={style.staticLabel}>
                                Time
                            </div>
                        </div>
                        <div className="col-11">
                            <div className="row gx-3">
                                <StatusItem item={time} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={`${style.kpiRow} row gx-3`}>
                        <div className="col-1">
                            <div className={style.staticLabel}>
                                Qual.
                            </div>
                        </div>
                        <div className="col-11">
                            <div className="row gx-3">
                                <StatusItem item={quality} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={`${style.kpiRow} row gx-3`}>
                        <div className="col-1">
                            <div className={style.staticLabel}>
                                Issues /<br />Concerns
                            </div>
                        </div>
                        <div className="col-11">
                            <div className="row gx-3">
                                <StatusItem item={issues} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={`${style.kpiRow} row gx-3`}>
                        <div className="col-1">
                            <div className={style.staticLabel}>
                                Risks
                            </div>
                        </div>
                        <div className="col-11">
                            <div className="row gx-3">
                                <StatusItem item={risks} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={`${style.kpiRow} row gx-3`}>
                        <div className="col-1">
                            <div className={style.staticLabel}>
                                Res. /<br /> Team
                            </div>
                        </div>
                        <div className="col-11">
                            <div className="row gx-3">
                                <StatusItem item={resources} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                    <div className={`${style.kpiRow} row gx-3`}>
                        <div className="col-1">
                            <div className={style.staticLabel}>
                                Cost
                            </div>
                        </div>
                        <div className="col-11">
                            <div className="row gx-3">
                                <StatusItem item={cost} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row gx-3 mt-4 p-1">
                    <div className="col-6">
                        <h3 className="text-md-500 BaseMainColor mb-3">
                            Current Period Progress
                        </h3>
                        <ProgressItem title="Accomplishment's Highlights" placeholder="Accomplished highlights is empty" kpi="CP_Accomplished" period={progressTrackerPeriod} item={currentPeriodProgress && currentPeriodProgress.accomplished} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                        <ProgressItem title="Planned but not accomplished" placeholder="Planned but not accomplished empty" kpi="CP_Planned" period={progressTrackerPeriod} item={currentPeriodProgress && currentPeriodProgress.planned} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                    </div>
                    <div className="col-6">
                        <h3 className="text-md-500 BaseMainColor mb-3">
                            Next Period Progress
                        </h3>
                        <ProgressItem title="Planned’s Highlights/ Focus" placeholder="Planned’s Highlights/ Focus is empty" kpi="NP_Planned" period={progressTrackerPeriod} item={nextPeriodProgressForecast && nextPeriodProgressForecast.planned} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                        <ProgressItem title="Communication Highlights & Priorities" placeholder="Communication Highlights & Priorities is empty" kpi="NP_Communication" period={progressTrackerPeriod} item={nextPeriodProgressForecast && nextPeriodProgressForecast.communication} updateStatus={(e) => handleUpdateStatus(e)} disabled={readOnly} />
                    </div>
                </div>
                <div className="row gx-3 mt-4 p-1">
                    <div className="col-6">
                        <HealthStatusTextField
                            title="Major Risks and Mitigation"
                            content={majorRisksIssues?.risksMitigation || ''}
                            disabled={readOnly}
                            onChange={(e) => handleUpdateStatus({ kpi: 'RisksMitigation', description: e, period: progressTrackerPeriod })}
                        />
                    </div>
                    <div className="col-6">
                        <HealthStatusTextField
                            title="Major Dependencies"
                            content={majorRisksIssues?.dependencies || ''}
                            disabled={readOnly}
                            onChange={(e) => handleUpdateStatus({ kpi: 'Dependencies', description: e, period: progressTrackerPeriod })}
                        />
                    </div>
                </div>
                <div className="row gx-3 mt-2 p-1">
                    <div className="col-12">
                        <HealthStatusTextField
                            title="Special Concerns"
                            content={specialConcerns || ''}
                            disabled={readOnly}
                            onChange={(e) => handleUpdateStatus({ kpi: 'SpecialConcerns', description: e, period: progressTrackerPeriod })}
                        />
                    </div>
                </div>
            </div >
        </>
    );
}

export default HealthStatus;